export default __webpack_public_path__ + "static/media/ostukorv.9cfeb3ff.png";